/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'pinterest': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 18.462',
    data: '<path pid="0" d="M7.75 0C2.69 0 0 3.243 0 6.778c0 1.639.916 3.685 2.383 4.333.222.1.344.057.394-.15.043-.157.236-.912.329-1.269a.325.325 0 0 0-.079-.321 4.207 4.207 0 0 1-.873-2.551 4.974 4.974 0 0 1 5.3-4.861c2.884 0 4.9 1.874 4.9 4.554 0 3.029-1.6 5.124-3.686 5.124a1.651 1.651 0 0 1-1.739-2.024 21.875 21.875 0 0 0 .973-3.727 1.431 1.431 0 0 0-1.481-1.575c-1.174 0-2.125 1.162-2.125 2.722a3.886 3.886 0 0 0 .351 1.661s-1.159 4.689-1.374 5.566a12.438 12.438 0 0 0 .086 4.091.122.122 0 0 0 .222.057 14.532 14.532 0 0 0 1.911-3.6c.143-.527.73-2.665.73-2.665a3.189 3.189 0 0 0 2.691 1.283c3.535 0 6.09-3.107 6.09-6.963-.014-3.7-3.177-6.464-7.25-6.464" fill-rule="evenodd"/>'
  }
})
